









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import LoggedOnComponent from "@/components/zorgID/LoggedOnComponent.vue";

@Component({
  components: {
    LoggedOnComponent,
  },
})
export default class MainToolbar extends Vue {}
